
export default {
  props: {
    position: {
      type: String,
      default: 'top left',
    },

    variant: {
      type: String,
      default: null,
      validator: (val) => !val || ['text'].includes(val),
    },
  },
}
